export default __webpack_public_path__ + "static/media/car.e536f8bd.gif";